import type { ReactNode } from 'react';

export const symbol_reset_iso: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-351v-83q0-19 13-32t32-13l82 1-127 127Zm0 161v-85l204-203h84L480-190Zm4 66 352-352q15 5 26 16.5t16 26.5L527-81q-16-5-27-16t-16-27Zm122 44 274-274v85L691-80h-85Zm162 0 112-112v67q0 19-13 32t-32 13h-67ZM480-780q-125 0-212.5 87.5T180-480q0 81 38.5 147.5T320-226v-84q0-13 8.5-21.5T350-340q13 0 21.5 8.5T380-310v160q0 13-8.5 21.5T350-120H190q-13 0-21.5-8.5T160-150q0-13 8.5-21.5T190-180h91q-73-48-117-127t-44-173q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q123 0 216.5 72.5T824-583q4 12-2 22.5T804-546q-12 4-23-2t-15-18q-29-92-107-153t-179-61Z"
		/>
	</svg>
);
